import { Component, inject, input, model } from '@angular/core';
import { HeaderDeclassificaOperazioniMassive } from '../models/operazioni-massive.model';
import { DocumentiSearchDocRow } from 'src/app/shared/models/documento-search.model';
import { DestroyReportFileFormat } from '../models/operazioni-massive-service.model';
import { OperazioniMassiveService } from '../services/operazioni-massive.service';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-riepilogo-declassifica-dialog',
  template: `
    <p-dialog [(visible)]="isOpen" [modal]="true" [closable]="false" [closeOnEscape]="false" [resizable]="false"  [style]="{ width: '50%' }">
      <p-header>
        <span>Riepilogo Declassifica</span>
        </p-header>
          <app-riepilogo-declassifica [header]="header()" [items]="documents()"  [showOnly]="true"></app-riepilogo-declassifica>
        <p-footer>
          <p-splitButton  [disabled]="!header || !documents().length"
                          icon="fas fa-download" label="Scarica Riepilogo" (onClick)="print()" 
                          styleClass="pr-0 mr-0"
                          [model]="downloadCommands"/>

          <button pButton type="button" label="Chiudi" class="p-button-secondary ml-2" title="Chiudi" (click)="close()"></button>
      </p-footer>      
    </p-dialog>
  `,
  styles: ``
})
export class RiepilogoDeclassificaDialogComponent {

  private readonly operazioniMassive = inject(OperazioniMassiveService);
    
  public id = input.required<number|undefined>();
  public header = input<HeaderDeclassificaOperazioniMassive | undefined>(undefined);
  public documents = input.required<DocumentiSearchDocRow[]>();
  public isOpen = model<boolean>(false);

  public downloadCommands: MenuItem[];

  constructor() {
    this.downloadCommands = [
      {
          label: 'Formato PDF',
          command: () => {
              this.print();
          }
      },
      {
          label: 'Formato Word',
          command: () => {
              this.printWord();
          }
      },
    ];  
  }
    
  public close(): void {
    this.isOpen.set(false);
  }
  public print(): void {
    this.generateReport( DestroyReportFileFormat.PDF);
  }

  public printWord(): void {
    this.generateReport( DestroyReportFileFormat.Word);
  }

  public generateReport( format: DestroyReportFileFormat = DestroyReportFileFormat.Word): void {
  
    setTimeout(() => {
      const operazioneId = this.id();
      
      if (operazioneId)
        this.operazioniMassive.report(operazioneId, format);
    }, 100);
  }  
}
